module.exports = ".card{\r\n    border-color: #f1f5f5db;\r\n    background-color: #f1f5f5db;\r\n    border-radius: 0;\r\n}"